module.exports = __webpack_public_path__ + "static/media/schmodelplain-withR-black.36fa3d31.png";